
import { css } from 'lit';
export default css`
:host{
  color:var(--neutral-charcoal);
  --closed-height:auto;
  --open-height:auto;

  display:block;
}

:host([variant='secondary']) .accordion-panel--button{
    color:var(--purple-indigo);
  }

:host([variant='secondary']) .accordion-panel--heading:hover .label, :host([variant='secondary']) .accordion-panel--heading:focus-within .label{
        color:var(--primary-eggplant);
      }

:host([variant='secondary']) .accordion-panel--label{
    font-size:var(--fs-body-mobile);
    font-weight:var(--fw-medium);
  }

@media (min-width: 992px){

:host([variant='secondary']) .accordion-panel--label{
      font-size:var(--fs-body)
  }
    }

:host([variant='secondary']) .secondary-label{
    font-size:var(--fs-sm);
  }

:host([variant='secondary']) .accordion-panel--icon{
    display:none;
  }

:host([active]) .accordion-panel--heading{
    border-color:var(--purple-indigo);
  }

:host([active]) .accordion-panel{
    padding-bottom:var(--spacing-5);
    transition:height ease-in-out 0.3s;
    height:auto;
    height:var(--open-height, auto);
  }

@media (min-width: 992px){

:host([active]) .accordion-panel{
      padding-bottom:var(--spacing-6)
  }
    }

:host([active]) .accordion-panel--content.loaded{
    display:flex;
    flex-direction:column;
    opacity:1;
    height:auto;
    transition:all ease-in-out 0.2s;
    row-gap:var(--spacing-5);
  }

:host([active]) .label,
  :host([active]) pc-icon{
    color:var(--purple-indigo);
  }

.accordion-panel{
  display:flex;
  flex-direction:column;
  width:100%;
  transition:height ease-in-out 0.3s;
  height:auto;
  height:var(--closed-height, auto);
  overflow:hidden;
}

.accordion-panel--heading{
  border-top:2px solid var(--purple-medium-neutral);
  display:flex;
  width:100%;
  justify-content:space-between;
  cursor:pointer;
}

.accordion-panel--heading:hover .label,
    .accordion-panel--heading:hover pc-icon,
    .accordion-panel--heading:focus-within .label,
    .accordion-panel--heading:focus-within pc-icon{
      color:var(--purple-indigo);
    }

.accordion-panel--button{
  padding:var(--spacing-5) var(--spacing-2);
  border:0px solid;
  background:transparent;
  width:100%;
  transition:all 0.3s ease-in;
  position:relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
  cursor:pointer;
  text-align:left;
}

@media (min-width: 992px){

.accordion-panel--button{
    padding:var(--spacing-6) var(--spacing-2)
}
  }

.accordion-panel--label{
  display:flex;
  flex-direction:column;
  gap:0.75rem;
  align-items:flex-start;
}

@media (min-width: 992px){

.accordion-panel--label{
    align-items:center;
    flex-direction:row;
    gap:1rem
}
  }

.secondary-label{
  font-size:1rem;
  color:var(--neutral-medium-gray);
}

@media (min-width: 992px){

.secondary-label{
    font-size:1.125rem
}
  }

.accordion-panel--content{
  display:flex;
  opacity:0;
  padding:0 var(--spacing-2);
}

.accordion-panel--content.column{
  flex-direction:column;
}

.accordion-panel--content.loaded{
  opacity:0;
  height:0px;
  transition:all ease-in-out 0.2s;

}
`;